/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	focusPadding: {
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
	footer: {
		borderTopWidth: token('border.width.selected'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
		paddingTop: token('space.050'),
		paddingBottom: token('space.050'),
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
});

export const Footer = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div
		css={[styles.footer, fg('adminhub_paginated_picker_focus_fixes') && styles.focusPadding]}
		{...props}
	>
		{children}
	</div>
);
